import { Outlet } from 'react-router-dom';
import { NotificationCenter } from '@/app/layout/NotificationCenter';

/**
 * The signed-out shell: no rail, no content card — the auth screens own the
 * whole viewport.
 */
export function AuthLayout() {
  return (
    <div className="shell shell--bare">
      <Outlet />
      <NotificationCenter />
    </div>
  );
}
